import styled, { css } from 'styled-components'

import { Button, ButtonPrimary, ButtonIcon } from '../Button/styles'

export const WrapperExibition = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin: 0px 0px 20px 0px;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 4px;
    background: rgb(255, 255, 255);
    padding: 30px 30px 10px;
    border-width: 1px;
    border-style: solid;
    border-color: rgb(229, 229, 229);
    border-image: initial;
    border-radius: 4px;
    width: 100%;
  `}
`

export const col_group = styled.div`
  ${() => css`
    width: 100%;
    margin-left: -10px;
    margin-right: -10px;
  `}
`

export const form_group = styled.div`
  ${() => css`
    margin-bottom: 16px;
    position: relative;
    font-size: 14px;
  `}
`

export const label = styled.div`
  ${() => css`
    font-size: 14px;
    font-weight: 600;
    color: #4a4a4a;
    display: block;
    letter-spacing: -1px;
    margin-bottom: 4px;
    display: 'flex';
  `}
`

export const col12 = styled.div`
  ${() => css`
    min-height: 1px;
    padding-left: 10px;
    padding-right: 10px;
    position: relative;
    width: 100%;
  `}
`
export const col8 = styled.div`
  ${() => css`
    min-height: 1px;
    padding-left: 10px;
    padding-right: 10px;
    @media screen and (min-width: 801px) {
      width: 66.666666666667%;
    }
    @media screen and (max-width: 800px) {
      width: 100%;
    }
  `}
`

export const col6 = styled.div`
  ${() => css`
    min-height: 1px;
    padding-left: 10px;
    padding-right: 10px;
    @media screen and (max-width: 800px) {
      width: 100%;
    }
    @media screen and (min-width: 801px) {
      width: 50%;
    }
  `}
`

export const col4 = styled.div`
  ${() => css`
    min-height: 1px;
    padding-left: 10px;
    padding-right: 10px;
    @media screen and (max-width: 800px) {
      width: 100%;
    }
    @media screen and (min-width: 801px) {
      width: 33.3333333333%;
    }
  `}
`

export const box = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
`

export const perfilBoxFooter = styled.div`
  ${() => css`
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    margin: 10px;
    display: flex;
    align-items: center;
  `}
`
export const button = styled.button`
  ${() => css`
    border-radius: 4px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 14px;
    padding: 12px 16px;
    text-align: center;
    display: inline-block;
    background: transparent;
    border: 2px solid #d22630;
    color: #d22630;
    cursor: pointer;
    &:hover {
      border-color: #4a4a4a;
      color: #4a4a4a;
    }
    @media screen and (max-width: 800px) {
      width: 97%;
      margin-bottom: 10px;
    }
    @media screen and (min-width: 801px) {
      &:not(:first-child) {
        margin-left: 15px;
      }
    }
  `}
`
export const o = styled.p`
  ${() => css`
    color: #d22630;
    display: inline-block;
    margin-left: 4px;
  `}
`
export const AdvanceButton = styled.button`
  cursor: pointer;
  ${({ theme, disabled }) => css`
    ${Button(theme)}
    ${ButtonPrimary(theme)}
    ${ButtonIcon}

    &:hover {
      background: #a71e26;
    }
    ${disabled &&
    css`
      background: ${theme.colors.grey};
    `}

    padding: 12px 16px;
    font-size: 14px;
  `}
  @media screen and (max-width: 800px) {
    width: 97%;
    margin-bottom: 10px;
  }
`
